import { render, staticRenderFns } from "./FixPersonForm.vue?vue&type=template&id=41d8f5b1&scoped=true&"
import script from "./FixPersonForm.vue?vue&type=script&lang=js&"
export * from "./FixPersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d8f5b1",
  null
  
)

export default component.exports